"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateHeadCount = void 0;
const types_shared_1 = require("../types.shared");
const validateHeadCount = ({ dateError, userState, filteredLocations, }) => {
    if (!(userState === null || userState === void 0 ? void 0 : userState.time)) {
        return {
            result: (0, types_shared_1.ok)(),
        };
    }
    const minHeadCount = 0;
    const maxHeadCount = filteredLocations.reduce((acc, location) => Math.max(location.details.gmMaxOrder || 0, acc), 0) || Infinity;
    if (!userState.headCount)
        return {
            result: (0, types_shared_1.error)({ code: 'INVALID_HEAD_COUNT' }),
        };
    if (userState.headCount <= 0)
        return {
            result: (0, types_shared_1.error)({ code: 'INVALID_HEAD_COUNT' }),
        };
    if (userState.headCount < minHeadCount)
        return {
            result: (0, types_shared_1.error)({ code: 'TOO_LOW' }),
        };
    if (userState.headCount > maxHeadCount)
        return {
            result: (0, types_shared_1.error)({ code: 'TOO_HIGH' }),
        };
    if (dateError === 'CLOSED_LARGE_ORDER')
        return {
            result: (0, types_shared_1.error)({ code: 'PAST_THRESHOLD' }),
        };
    return {
        result: (0, types_shared_1.ok)(),
    };
};
exports.validateHeadCount = validateHeadCount;
